import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOpenAddCardModal } from "../../actions/stripe";

export default function PayWithCard() {
  const dispatch = useDispatch()
  const { selectedCard } = useSelector(state => state.stripe);

  const backgroundImg = selectedCard?.card?.brand === "visa" ?
    (`assets/img/newCardDesign.png`)
    : selectedCard?.card?.brand === 'jcb' ?
      (`assets/img/newCardDesign1.png`)
      : selectedCard?.card?.brand === 'mastercard' ?
        (`assets/img/newCardDesign2.png`)
        : selectedCard?.card?.brand === 'unionpay' ?
          (`assets/img/newCardDesign3.png`)
          : selectedCard?.card?.brand === 'amex' ?
            (`assets/img/newCardDesign4.png`)
            : selectedCard?.card?.brand === 'dinersCard' ?
              (`assets/img/newCardDesign5.png`)
              : (`assets/img/newCardDesign.png`)



  const logoImage = selectedCard?.card?.brand === "visa" ?
    (`assets/img/visaColor.png`)
    : selectedCard?.card?.brand === 'jcb' ?
      (`assets/img/jcbCard.png`)
      : selectedCard?.card?.brand === 'mastercard' ?
        (`assets/img/masterCard.png`)
        : selectedCard?.card?.brand === 'unionpay' ?
          (`assets/img/unionCard.png`)
          : selectedCard?.card?.brand === 'amex' ?
            (`assets/img/americanCard.png`)
            : selectedCard?.card?.brand === 'dinersCard' ?
              (`assets/img/dinersCard.png`)
              : (`assets/img/australiaCard.png`)

  const addNewCardunc = () => {
    dispatch(setOpenAddCardModal(true))
  };

  return (
    <div className="cardPayMargin">
      <div className="cardSizeSection cardBackground" style={{ backgroundImage: `url(${backgroundImg})` }}>
        <div className="payCardupperDetails">
          <div className="chipWifiSection">
            <img src="assets/img/cardChip.svg" alt="" />
            <img src="assets/img/wifiIcon.svg" alt="" />
          </div>

          <div className="paymentcardSection">
            <div className="cardDetils">
              <h6 className="m-0">NUMBER</h6>
              <p className="m-0">**** **** **** {selectedCard?.card?.last4 || "****"}</p>
            </div>
            <div className="cardDetils">
              <h6 className="m-0">VALID UNTIL</h6>
              <p className="m-0">{selectedCard?.card?.exp_month || "-"}/{selectedCard?.card?.exp_year || "-"}</p>
            </div>
          </div>
        </div>

        <div className="payCardHolderDetails">
          <div className="payCardHolderName">
            <p className="m-0">NAME</p>
            <h4 className="m-0">{selectedCard?.billing_details?.name || "-"}</h4>
          </div>
          <div className="cardLogo">
            <img src={logoImage} alt="" />
          </div>
        </div>
      </div>

      <div onClick={addNewCardunc} className="cardSizeSection addCardBackground">
        <div className="AddPayCard">
          <img src="assets/img/plusIcon.svg" alt="" />
          <p>Add new card</p>
        </div>
      </div>
    </div>
  );
}
